import { render, staticRenderFns } from "./PassportPage.vue?vue&type=template&id=441f1d9c&scoped=true&"
import script from "./PassportPage.vue?vue&type=script&lang=js&"
export * from "./PassportPage.vue?vue&type=script&lang=js&"
import style0 from "./PassportPage.vue?vue&type=style&index=0&id=441f1d9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f1d9c",
  null
  
)

export default component.exports